import AOS from 'aos';

export default () => {
    AOS.init({
        once: true,
    });

};
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.timeline')) {
        setTimeout(() => {
            AOS.refresh();
        }, 800);
    }
});
